import ModalDialog from '@ui/modal/ModalDialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
const ErrorModal = (props) => {
    let { t } = useTranslation();
    return props.message ? (React.createElement(ModalDialog, { isOpen: true, overlayClassName: "mobile-visible", className: "modal--fixed-small", onRequestClose: () => props.onClose(), contentLabel: props.label ? props.label : t('label.sorry') },
        React.createElement("div", { role: "alert", dangerouslySetInnerHTML: { __html: props.message } }))) : (React.createElement(React.Fragment, null));
};
export default ErrorModal;
